var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5 0.527466)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52001 19.7575C4.4869 19.9195 4.49447 20.0871 4.54205 20.2455C4.58963 20.4038 4.67573 20.5479 4.79265 20.6648C4.90956 20.7817 5.05364 20.8678 5.21199 20.9154C5.37034 20.963 5.53802 20.9706 5.70001 20.9375L9.51001 20.1575L5.30001 15.9475L4.52001 19.7575ZM20.344 7.23447L18.224 5.11247C18.0381 4.92655 17.8173 4.77916 17.5743 4.67878C17.3314 4.57839 17.0709 4.52697 16.808 4.52747C16.296 4.52747 15.784 4.72247 15.393 5.11247L5.63601 14.8705L10.586 19.8205L20.343 10.0625C20.718 9.68741 20.9286 9.1788 20.9286 8.64847C20.9286 8.11814 20.718 7.60952 20.343 7.23447H20.344Z",
    fill: "#A5ADBA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/edit-filled.59a623aabc58c95cbdd03007c7d102b9.svg";
export { ForwardRef as ReactComponent };